(() => {
  'use strict';

  const initialize = (root = document) => {
    root.querySelectorAll('[data-ugc-reels]:not([data-initialized])').forEach((section) => {
      section.dataset.initialized = 'true';
      const track = section.querySelector('[data-ugc-track]');
      const cards = [...section.querySelectorAll('[data-ugc-card]')];
      const previous = section.querySelector('[data-ugc-prev]');
      const next = section.querySelector('[data-ugc-next]');
      if (!track) return;

      const pauseOthers = (activeVideo) => {
        cards.forEach((card) => {
          const video = card.querySelector('video');
          if (!video || video === activeVideo) return;
          video.pause();
          card.classList.remove('is-playing');
        });
      };

      cards.forEach((card) => {
        const video = card.querySelector('video');
        const playButton = card.querySelector('[data-ugc-play]');
        const soundButton = card.querySelector('[data-ugc-sound]');
        if (!video || !playButton) return;

        const setMuted = (muted) => {
          video.defaultMuted = muted;
          video.muted = muted;
          video.volume = muted ? 0 : 1;

          if (muted) {
            video.setAttribute('muted', '');
          } else {
            video.removeAttribute('muted');
          }

          const soundIcon = soundButton?.querySelector('span');
          if (soundIcon) soundIcon.textContent = muted ? '🔇' : '🔊';
          soundButton?.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
        };

        setMuted(false);

        const togglePlayback = async () => {
          if (video.paused) {
            pauseOthers(video);
            if (!video.dataset.soundChoice) setMuted(false);
            try {
              await video.play();
              card.classList.add('is-playing');
              playButton.setAttribute('aria-label', 'Pause video');
            } catch (error) {
              card.classList.remove('is-playing');
            }
          } else {
            video.pause();
            card.classList.remove('is-playing');
            playButton.setAttribute('aria-label', 'Play video');
          }
        };

        playButton.addEventListener('click', togglePlayback);
        video.addEventListener('click', togglePlayback);
        video.addEventListener('pause', () => card.classList.remove('is-playing'));

        soundButton?.addEventListener('click', (event) => {
          event.stopPropagation();
          video.dataset.soundChoice = 'true';
          setMuted(!video.muted);
        });
      });

      const scrollByCard = (direction) => {
        const firstCard = cards[0];
        const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        const distance = (firstCard?.getBoundingClientRect().width || track.clientWidth) + gap;
        track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      };

      previous?.addEventListener('click', () => scrollByCard(-1));
      next?.addEventListener('click', () => scrollByCard(1));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
